// extracted by mini-css-extract-plugin
module.exports = {"CircleIcon":"CircleIcon_CircleIcon__2wpqz"};